import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Field, FieldArray, formValueSelector } from 'redux-form';
import { TextField, SelectField } from 'redux-form-material-ui';
import { CSSTransitionGroup } from 'react-transition-group';
import { MdChevronLeft as ChevronLeftIcon } from 'react-icons/md';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import * as validator from 'helpers/Validator';

import { roomTypes } from '../SavedRooms';
import InternalRooms from './InternalRooms';

const style = {
  room_card_field: {
    marginTop: '-15px',
    fontSize: '14px',
    textAlign: 'left',
    width: '100%',
  },
  room_card_icon: {
    padding: 0,
    verticalAlign: 'text-bottom',
    width: 'none',
    height: 'none',
    float: 'left',
  },
};

class RoomCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentNode: props.name,
    };
  }

  render() {
    const { index } = this.props;
    const { currentNode } = this.state;

    return (
      <div key={`room_card_${currentNode}_${index}`}>
        <CSSTransitionGroup
          transitionName="add_unit"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          <div className="row" style={{ marginBottom: '25px' }}>
            {this.renderBreadCrumb()}
            <div className="row">
              <div className="col-xs-6">
                <Field
                  name={`${currentNode}.room_type`}
                  validate={[validator.required]}
                  component={SelectField}
                  floatingLabelText="Room Type"
                  style={style.room_card_field}
                >
                  {roomTypes.map((room) => (
                    <MenuItem
                      key={`room_card_${index}_room_type_${room.value}`}
                      value={room.value}
                      primaryText={room.primaryText}
                    />
                  ))}
                </Field>
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name={`${currentNode}.name`}
                  type="text"
                  component={TextField}
                  validate={[validator.required]}
                  floatingLabelText="Name"
                  style={style.room_card_field}
                />
              </div>
            </div>
            <div className="row">
              <h4 style={{ paddingLeft: '15px' }}>Internal Rooms</h4>
              <FieldArray
                name={`${currentNode}.rooms`}
                changeNode={this.changeCurrentNode}
                component={InternalRooms}
              />
            </div>
          </div>
        </CSSTransitionGroup>
      </div>
    );
  }

  changeCurrentNode = (currentNode) => {
    this.setState({
      currentNode,
    });
  };

  changeNode = (level) => {
    const { skipNodes } = this.props.formProps;
    const levels = this.state.currentNode.split('.');
    this.setState({
      currentNode: levels.slice(0, level + skipNodes).join('.'),
    });
  };

  getRoomName = (index) => {
    // Skip initial nodes if currently in Units[x].rooms...
    // skipNodes will be 0 if it is just PropertyRooms
    const { skipNodes } = this.props.formProps;
    let roomIndexArray = this.state.currentNode.split('.');
    roomIndexArray = roomIndexArray.splice(0, index + skipNodes);

    const room = this.props.getFormValue(roomIndexArray.join('.'));
    return room ? room.name : '';
  };

  renderBreadCrumb = () => {
    const { skipNodes } = this.props.formProps;
    let levels = this.state.currentNode.split('.');
    if (skipNodes > 0) {
      levels.splice(0, skipNodes);
    }
    if (levels.length <= 1) {
      return null;
    }
    return (
      <div className="row" style={{ marginBottom: '15px' }}>
        <IconButton style={style.room_card_icon} onClick={() => this.changeNode(levels.length - 1)}>
          <ChevronLeftIcon size={24} style={{ padding: 0 }} />
        </IconButton>
        <p>
          {levels.map(
            (level, index) =>
              index !== levels.length - 1 && (
                <span>
                  <button
                    type="button"
                    className="link-button"
                    key={`internal_level_${index}`}
                    onClick={() => this.changeNode(index + 1)}
                  >
                    {this.getRoomName(index + 1)}
                  </button>
                  {index !== levels.length - 2 && ' / '}
                </span>
              )
          )}
        </p>
      </div>
    );
  };
}
const getFormValue = (state) => (formValueString) => {
  const selector = formValueSelector('add_property');
  return selector(state, formValueString);
};

const mapStateToProps = (state) => {
  return {
    getFormValue: getFormValue(state),
  };
};

export default connect(mapStateToProps)(RoomCard);
